import ColorStatus from "./ColorStatus/ColorStatus";
import classes from "./BookTable.module.scss";
import IconButton from "../../UI/IconButton/IconButton";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BookTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { selectedTable } = useSelector((state) => state.finalOrder);

  const goToCategories = () => {
    navigate("/orders/categories");
  };

  return (
    <div className={classes.BookTable}>
      <ColorStatus text={t("OCCUPIED")} status="Occupied" />
      <ColorStatus text={t("RESERVED")} status="Reserved" />
      <ColorStatus text={t("AVAILABLE")} status="Available" />
      <ColorStatus text={t("DISABLED")} status="Disabled" />
      <div className={classes.Order}>
        <p className={classes.TableNum}>
          {t("TABLE")} {selectedTable.tableNum}
        </p>
        <p className={classes.OrderNum}>
          {t("ORDER")} {selectedTable.id}
        </p>
      </div>
      <IconButton
        disabled={!selectedTable.id}
        icon="bag"
        iconPosition="left"
        text="Select &#38; Place Order"
        onClicked={goToCategories}
      />
    </div>
  );
};

export default BookTable;
